import type { FaireProductEntity } from "../../entity_types/product";

export const p_8k7b2hfb6j: FaireProductEntity = {
  token: "p_8k7b2hfb6j",
  type: "product",
  name: "Tulsi Lemon-Aid - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/99df3418826dc1572220ca4eea9250f13b28b00fa6f46ee90bdcdd52aaadfc92.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e1a31148cfb3664d13bd54a2f335facfb18cc34befc479e273cb34b0a2ea6c91.jpeg",
    "https://cdn.faire.com/fastly/e85612ed55d7f67c69340d6e975ef054caa4815c201ada43fa063f00a0ae8e27.jpeg",
    "https://cdn.faire.com/fastly/8049a73043ffd1987610eb0d2ff8075b641cf9a37f5b83758806cd965e883c2f.jpeg",
    "https://cdn.faire.com/fastly/332dc4d09429cb0335c5d5c1598dafaf7eb07bfe34b15458721f599919a99a80.jpeg"
  ],
  priceDollars: 58,
  description: "SUPERFOOD TEA BLEND\n\n100% Refreshment, 0% BS. Inspired by the timeless flavours of black tea and lemon, this caffeine-free dream packs an ultra-healthy punch with green rooibos and adaptogenic tulsi. Bringing a wave of freshness, lemon myrtle and lemon peel make this a blissful sip, hot or iced. Caffeine, sugar or flavouring? Nuh-uh honey.\n\n100% ORGANIC - ADAPTOGENIC - NUTRITIONIST FORMULATED \n\nHow to Enjoy:\n\n * Steep tea in 1 cup of 80° water for 4-6 minutes. \n * Try me with a squeeze of lemon. \n * Try me iced or cold-brewed for a hydrating and cleansing tonic. \n\nWhen to Steep:\n\n * A nourishing all-day, caffeine-free tea \n * To calm your nerves \n * To soothe your stomach between meals \n * As a refreshing summer tonic \nCaffeine-free\n",
  tags: [],
  msrpDollars: 116,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:44.607Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
